import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import images from "../../assets/images/constantImages";
import { MdCurrencyRupee } from "react-icons/md";
import icons from "../../assets/images/constantIcons";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { checkoutOrder, getOrdersDetails } from "./OrderSlice";
import { handleError } from "../Common/ApiCommon/ApiService";
import Navbar from "./Navbar";
import { PacmanLoader } from "react-spinners";

const CartOrders = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isOrderStatusModalOpen, setIsOrderStatusModalOpen] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("UPI");
  const [selectedUPI, setSelectedUPI] = useState("phonepay");
  const [cartItems, setCartItems] = useState(() => {
    const stored = localStorage.getItem("cart");
    return stored ? JSON.parse(stored) : ""
  })
  const [showLoginModal, setShowLoginModal] = useState(false);
  const hasToken = () => !!localStorage.getItem("canteenToken");
  const canteenUserId = localStorage.getItem('canteen_user_id');
  const [checkoutId, setCheckoutId] = useState(null);
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state?.checkout || {});
  const { orderData } = useSelector((state) => state?.orders || {});

  console.log("canteenUserId",canteenUserId);
  
  const upiOptions = [
    { label: "Paytm UPI", icon: images.Paytm, value: "paytm" },
    { label: "PhonePe UPI", icon: images.phonepay, value: "phonepay" },
    { label: "GPay UPI", icon: images.Gpay, value: "gpay" },
    { label: "Bhim UPI", icon: images.bhim, value: "bhim" },
  ];

  const updateLocalStorage = (updatedCart) => {
    setCartItems(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const handleIncrease = (itemId) => {
    const updated = { ...cartItems };
    if (updated[itemId]) {
      updated[itemId].quantity += 1;
    }
    updateLocalStorage(updated);
  };

  const handleDecrease = (itemId) => {
    const updated = { ...cartItems };
    if (updated[itemId]) {
      if (updated[itemId].quantity === 1) {
        delete updated[itemId];
      } else {
        updated[itemId].quantity -= 1;
      }
    }
    updateLocalStorage(updated);
  };

  const total = Object.values(cartItems).reduce((acc, item) => acc + item?.price * item?.quantity, 0);

  const handlePayNow = async () => {

    if (!paymentMethod) {
      toast.error("Please select a payment method.");
      return;
    }

    if (paymentMethod === "UPI" && !selectedUPI) {
      toast.error("Please select a UPI option.");
      return;
    }

    if (Object.keys(cartItems).length === 0) {
      toast.error("Your cart is empty.");
      return;
    }


    const total_price = Object.values(cartItems).reduce((acc, item) => acc + item?.price * item?.quantity, 0);

    const order_items = Object.values(cartItems).map(item => ({
      item_id: item.id,
      quantity: item.quantity,
    }));

    const payload = {
      canteen_user_id: Number(canteenUserId),
      order: {
        total_price,
        payment_type: paymentMethod === 'UPI' ? selectedUPI.toLowerCase() : 'cash',
        order_items,
      }
    };
    console.log("payload", payload);
    try {
      const response = await dispatch(checkoutOrder(payload)).unwrap();
      console.log("res", response);

      const orderId = response?.id;
      console.log("orderId", orderId);

      setCheckoutId(orderId);
      setIsModalOpen(false);
      toast.success("Order created succesfully !")
      setIsSuccessModalOpen(true);
      localStorage.removeItem("cart");
      setCartItems({});
    } catch (errors) {
      handleError(errors);
    }
  };

  useEffect(() => {
    if (checkoutId) {
      console.log(checkoutId);
      dispatch(getOrdersDetails(checkoutId));
    }
  }, [checkoutId, dispatch]);

  const onGoHome = () => {
    setIsSuccessModalOpen(false);
    navigate(`/menus/${canteenUserId}`);
  }
  const onTrackOrder = () => {
    setIsSuccessModalOpen(false);
    setIsOrderStatusModalOpen(true)
  }
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleString('en-US', options);
  };

    if (loading) return (
    <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50">
      <PacmanLoader color="#85bd3a" size={40} />
    </div>
  );

  return (
    <>
      <Navbar />
      <div className="h-auto md:h-[88vh] bg-[#e6f4d346] py-6 px-5 sm:px-8">
        <div className="flex justify-start gap-2 text-base text-G500 left-5">
          <Link to={`/menus/${canteenUserId}`}>
            <div className="flex gap-3 items-center cursor-pointer">
              <icons.FaArrowLeftLong />
              <h1 className="text-xl font-semibold">Cart</h1>
            </div>
          </Link>
        </div>

        <div className="flex flex-col md:flex-row justify-between px-0 py-3 md:p-0 lg:p-6 w-full md:gap-5 lg:gap-0">
          <div className="w-full lg:w-3/6 ">
            <p className="text-G800 text-lg font-semibold mb-5">Items you have selected</p>
            {Object?.values(cartItems)?.length === 0 ? (
              <div className="flex flex-col gap-4 items-center ">
                <img src={images.emptyCart} alt="emptyCart" loading="lazy" className="w-52 h-52" />
                <p className="text-G500 text-base">Your cart is empty</p>
                <Link to={`/menus/${canteenUserId}`}>
                  <button className="bg-slate-950 text-white px-6 py-2 rounded-md">Browse Menus</button>
                </Link>
              </div>
            ) : (
              <div className="flex flex-col gap-5  max-h-[64vh] overflow-y-auto vertical">
                {Object?.values(cartItems)?.map((item, i) => (
                  <div key={i} className="flex justify-between items-center bg-white shadow-md rounded-xl p-3 lg:px-6 lg:py-4 ">
                    <div className="flex items-center gap-6">
                      <img src={`https://headquater.pixoatic.com${item.image}`} alt={item.name} className="w-12 h-12 md:w-16 md:h-14 rounded-full" />
                      <div>
                        <p className="text-lg md:text-base lg:text-lg font-medium text-G800">{item.name}</p>
                        <p className="text-sm text-G500">X{item.quantity}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-sm font-semibold mb-1">₹ {(parseFloat(item.price) || 0).toFixed(2)}</p>
                      <div className="flex items-center border border-canteengreen  rounded-md">
                        <button onClick={() => handleDecrease(item.id)} className="px-2 text-canteengreen text-xl">−</button>
                        <span className="px-2">{item.quantity}</span>
                        <button onClick={() => handleIncrease(item.id)} className="px-2 text-canteengreen text-xl">+</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="w-full lg:w-2/5 xl:w-1/3 flex flex-col ">
            <div className='flex justify-between items-center mb-5 mt-4 md:mt-0'>
              <p className="text-G800 text-base lg:text-lg font-semibold">Missing something ?</p>
              <Link to={`/menus/${canteenUserId}`}>
                <button className='flex items-center px-3 bg-black text-white rounded-md py-1 text-sm md:text-base font-medium'>
                  <icons.FaPlus className='pr-2' /> Add More Items
                </button>
              </Link>
            </div>

            <p className="text-G800 text-lg font-semibold mb-5">Price Details</p>

            <div className=" bg-white shadow-md p-6 rounded-md">
              {/* Displaying Total Items */}
              <div className="flex justify-between items-center mb-2 font-medium text-base">
                <p >Total Items</p>
                <p className="flex items-center">
                  {Object.values(cartItems).length}
                </p>
              </div>
              <div className="flex justify-between items-center mb-2 font-medium text-base">
                <p className="">Total Quantity</p>
                <p className="flex items-center">
                  {Object.values(cartItems).reduce((acc, item) => acc + item.quantity, 0)}
                </p>
              </div>
              <div className="flex justify-between items-center mb-2 font-medium text-base">
                <p >Sub Total</p>
                <p className="flex items-center">
                  ₹ {Object.values(cartItems)
                    .reduce((acc, item) => acc + item.quantity * parseFloat(item.price), 0)
                    .toFixed(2)}
                </p>
              </div>
              {/* Discount  */}
              <div className="flex justify-between items-center mb-2 font-medium text-base">
                <p>Discount</p>
                <p className="flex items-center"> - </p>
              </div>

              <hr className="border-b mb-3" />

              {/* Displaying Total Price */}
              <div className="flex justify-between items-center mb-6">
                <p className="text-lg font-semibold">Grant Total</p>
                <p className="text-xl font-bold flex items-center">
                  <MdCurrencyRupee className="text-green font-bold" />
                  {Object.values(cartItems).reduce((acc, item) => acc + item.price * item.quantity, 0).toFixed(2)}
                </p>
              </div>

              {/* Checkout Button */}
              <button
                className="w-full bg-canteengreen text-white font-semibold py-3 rounded-lg"
                onClick={() => {
                  const cartItemCount = Object.values(cartItems || {}).length;
                  if (cartItemCount === 0) return toast.error("Please add items in your cart before checking out.", { duration: 2000 });
                  if (!hasToken()) {
                    setShowLoginModal(true);
                  } else {
                    setIsModalOpen(true);
                  }
                }}
              >
                Checkout
              </button>
            </div>
          </div>
        </div>
        {showLoginModal && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
            <div className="bg-white rounded-lg p-6 w-72 sm:w-96 shadow-lg relative">
              <h2 className="text-xl font-bold text-center text-G800 mb-4">Login Required</h2>
              <icons.IoClose onClick={() => setShowLoginModal(false)} className="absolute top-7 right-5 text-canteengreen font-bold text-lg cursor-pointer" />
              <p className="text-center text-G500 mb-6">
                Please log in to proceed to checkout.
              </p>
              <div className="flex justify-center">
                <button onClick={() => {
                  setShowLoginModal(false);
                  navigate("/canteen_UserLogin");
                }} className="px-4 py-[6px] rounded bg-canteengreen text-white font-semibold">
                  Login / Sign Up
                </button>
              </div>
            </div>
          </div>
        )}

        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative">
              <button
                onClick={() => setIsModalOpen(false)}
                className="absolute right-4 top-4 text-green text-xl"
              >
                <icons.IoClose />
              </button>

              <h2 className="text-xl font-semibold mb-4">Payment method</h2>

              <div className="flex gap-4 mb-6">
                <button
                  onClick={() => setPaymentMethod("UPI")}
                  className={`border rounded-lg px-12 py-4 flex justify-center items-center gap-2 ${paymentMethod === "UPI"
                    ? "bg-green50 border-canteengreen text-canteengreen font-semibold"
                    : "border-G30"
                    }`}
                >
                  <div className="flex flex-col items-center gap-2">
                    <icons.SlScreenSmartphone alt="UPI" className="text-2xl text-canteengreen" />
                    <p className="text-gray-700">UPI</p>
                  </div>
                </button>
                <button
                  onClick={() => setPaymentMethod("Cash")}
                  className={` border rounded-lg px-12 py-4 flex justify-center items-center gap-2 ${paymentMethod === "Cash"
                    ? "bg-green50 border-canteengreen text-canteengreen font-semibold"
                    : "border-G30"
                    }`}
                >
                  <div className="flex flex-col items-center gap-2">
                    <icons.MdOutlineAccountBalanceWallet alt="Cash" className="text-2xl text-canteengreen" />
                    <p className="text-gray-700 ">Cash</p>
                  </div>
                </button>
              </div>

              {paymentMethod === "UPI" && (
                <div className="space-y-3 mb-6">
                  {upiOptions.map((option) => (
                    <label
                      key={option.label}
                      className="flex items-center gap-3 cursor-pointer"
                    >
                      <input
                        type="radio"
                        name="upi"
                        value={option.value}
                        checked={selectedUPI === option.value}
                        onChange={() => setSelectedUPI(option.value)}
                        className="accent-canteengreen "
                        required
                      />
                      <img src={option.icon} alt={option.label} className="w-6 h-6 object-contain" />
                      <span>{option.label}</span>
                    </label>
                  ))}
                </div>
              )}

              <div className="flex justify-between items-center font-semibold text-2xl mb-4">
                <span>Total</span>
                <span className="flex items-center">
                  <icons.MdCurrencyRupee className="text-canteengreen" />
                  {total}
                </span>
              </div>

              <button
                onClick={handlePayNow}
                disabled={!paymentMethod || (paymentMethod === "UPI" && !selectedUPI)}
                className={`w-full text-white font-semibold py-3 rounded-lg ${(!paymentMethod || (paymentMethod === "UPI" && !selectedUPI)) ? 'bg-gray-400 cursor-not-allowed' : 'bg-canteengreen'}`}
              >
                Pay Now
              </button>
            </div>
          </div>
        )}

        {isSuccessModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative text-center">
              <button
                onClick={() => setIsSuccessModalOpen(false)}
                className="absolute right-4 top-4 text-green text-2xl"
              >
                <icons.IoClose />
              </button>

              <div className="flex justify-center mb-4">
                <div className="bg-green50 text-green rounded-full p-4">
                  <icons.HiCheckBadge className="w-20 h-20 text-[#38CE8C]" />
                </div>
              </div>

              <h2 className="text-xl font-semibold mb-2">Payment Success</h2>
              <p className="text-G500 text-sm mb-6">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </p>

              <div className="space-y-4">
                <button
                  onClick={onTrackOrder}
                  className="w-full bg-canteengreen text-white font-semibold py-3 rounded-lg"
                >
                  Track order status
                </button>
                <button
                  onClick={onGoHome}
                  className="w-full bg-canteencardcolor text-canteengreen font-semibold py-3 rounded-lg"
                >
                  Back to home
                </button>
              </div>
            </div>
          </div>

        )}

        {isOrderStatusModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-xl p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative text-center">
              <button
                onClick={() => {
                  setIsOrderStatusModalOpen(false);
                  navigate(`/menus/${canteenUserId}`);
                }}
                className="absolute right-4 top-4 text-green text-2xl"
              >
                <icons.IoClose />
              </button>

              <img
                src={images.orderdeatilslogo}
                alt="logo"
                className="w-12 h-12 mx-auto mb-5"
              />

              <p className="text-G500 mb-5 text-lg">Your order number is</p>
              <h2 className="text-4xl font-bold text-G500 mb-5">{orderData?.order_no}</h2>

              <hr className="border-dashed border-G50 my-5" />

              <div className="text-sm text-centre text-G500 mb-4 space-y-1">
                <p className="font-medium">
                  Order Id : <span className="text-G500">{orderData?.order_uniq_id}</span>
                </p>
                <p>
                  REG – <span className="text-G500">{formatDate(orderData?.date)}</span>
                </p>
              </div>

              <div className="text-sm text-left text-G500 mt-4">
                <div className="mb-4 font-medium flex justify-between">
                  <span>QTY ITEM</span>
                  <span>TOTAL</span>
                </div>
                {orderData.order_items.map((item, i) => (
                  <div key={i} className="flex justify-between py-3 text-sm">
                    <span>
                      {item.quantity} {item.item_name}
                    </span>
                    <span>₹ {item.total_price}</span>
                  </div>
                ))}
              </div>

              <hr className="border-dashed border-G50 my-4" />

              <div className="text-left text-sm text-G500 space-y-2">
                <div className="flex justify-between font-semibold">
                  <span>TOTAL</span>
                  <span>₹ {orderData?.total_price}</span>
                </div>
                <div className="flex justify-between font-semibold">
                  <span>Card Payment</span>
                  <span>₹ {orderData?.total_price}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CartOrders;
